import React, { useEffect, useState } from "react";
import "../scss/_OurResearch.scss";
import "../scss/_variables.scss";
import testData from "../testData/blogData.json";
import ResearchTagList from "./ResearchTagList";
import DisplayedResearchPosts from "./DisplayedResearchPosts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FilterDataAdvanced } from "filter-data-advanced/dist/FilterDataAdvanced";

const OurResearch = () => {
    const [currentFilter, setFilter] = useState("All");
    const [state, setState] = useState({
        query: "",
        list: [],
    });

    return (
        <div className="ourResearchContainer">
            <ResearchHero />
            <div className="blogContainer">
                <ResearchSearchAndFilter
                    currentFilter={currentFilter}
                    setFilter={setFilter}
                    state={state}
                    setState={setState}
                />
                <DisplayedResearchPosts
                    currentFilter={currentFilter}
                    results={state.list}
                />
            </div>
        </div>
    );
};

const ResearchSearchAndFilter = ({
    setFilter,
    currentFilter,
    state,
    setState,
}) => {
    let obj = new FilterDataAdvanced();
    const handleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        const results = obj.filterByKeyValue(testData, "title", searchTerm);
        setState({
            query: e.target.value,
            list: results,
        });
    };

    return (
        <div className="searchAndFilterContainer">
            <div className="topContainer">
                <div className="title">All Research</div>
                <div className="searchBox">
                    <button className="btnSearch">
                        <FontAwesomeIcon
                            className="searchIcon"
                            icon={faMagnifyingGlass}
                        />
                    </button>
                    <input
                        type="search"
                        placeholder="Search blog or articles"
                        className="inputSearch"
                        onChange={handleSearch}
                        value={state.query}
                    />
                </div>
            </div>
            <div className="bottomContainer">
                <ResearchTagList
                    currentFilter={currentFilter}
                    setFilter={setFilter}
                />
            </div>
        </div>
    );
};

const ResearchHero = () => {
    const [imageIndex, setImageIndex] = useState(0);
    const [prevIndex, setPrevIndex] = useState(0);

    const createTags = () => {
        const tagArray = testData[imageIndex].tag;
        return (
            <div className="tags">
                {tagArray.map((item, i) => (
                    <div className="tagContainer" key={i}>
                        <div className="tag">{item}</div>
                    </div>
                ))}
            </div>
        );
    };

    const mapImages = () => {
        return (
            <div className="imageContainer">
                {testData.map((item, i) => (
                    <img
                        key={i}
                        src={item.image}
                        alt={item.alt}
                        className={`sliderImage ${
                            i === imageIndex
                                ? "active"
                                : i === prevIndex
                                    ? "prev"
                                    : ""
                        }`}
                    />
                ))}
            </div>
        );
    };

    const sliderProgress = () => {
        const pink = "#d62c5e";
        const white = "#e7f3ff";
        return (
            <div className="progressContainer">
                {testData.map((_, index) => (
                    <button
                        className="progressButton"
                        onClick={() => {
                            setPrevIndex(imageIndex);
                            setImageIndex(index);
                            setTimeLeft(timeBetweenSlideOnClick);
                        }}
                        key={index}
                        style={{
                            backgroundColor:
                                index === imageIndex ? pink : white,
                            width: index === imageIndex ? "5.2em" : "5em",
                            height: index === imageIndex ? ".7em" : ".5em",
                        }}
                    ></button>
                ))}
            </div>
        );
    };

    const handleKeyDown = (event) => {
        if (event.key === "ArrowRight") {
            showNextImage();
            setTimeLeft(timeBetweenSlideOnClick);
        }
        if (event.key === "ArrowLeft") {
            showPrevImage();
            setTimeLeft(timeBetweenSlideOnClick);
        }
    };

    const timeBetweenSlideOnClick = 10;
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        if (timeLeft === 0) {
            showNextImage();
        }
        if (!timeLeft) {
            setTimeLeft(5);
        }
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            clearInterval(intervalId);
        };
    }, [timeLeft]);

    const showPrevImage = () => {
        setPrevIndex(imageIndex);
        setImageIndex((index) => {
            if (index === 0) return testData.length - 1;
            return index - 1;
        });
    };

    const showNextImage = () => {
        setPrevIndex(imageIndex);
        setImageIndex((index) => {
            if (index === testData.length - 1) return 0;
            return index + 1;
        });
    };

    const rightButtonPress = () => {
        showNextImage();
        setTimeLeft(timeBetweenSlideOnClick);
    };

    const leftButtonPress = () => {
        showPrevImage();
        setTimeLeft(timeBetweenSlideOnClick);
    };

    return (
        <div className="heroContainer">
            {mapImages()}
            <div className="info">
                <div className="researchTitle">
                    {testData[imageIndex].title}
                </div>
                {createTags()}
                {sliderProgress()}
            </div>
            <button
                className="leftButton sideButton"
                onClick={leftButtonPress}
            ></button>{" "}
            <button
                className="rightButton sideButton"
                onClick={rightButtonPress}
            ></button>
        </div>
    );
};

export default OurResearch;
